export default "__VITE_ASSET__Dt2qDe87__"